import { GetCompanyCalendlyLinkMeta, GetCompanyCalendlyLinkPayload } from 'types/store/GetCompanyCalendlyLink';
import { createAsyncReducer } from 'utils/Redux';

import { getCompanyCalendlyLinkActions } from '../actions';

export default createAsyncReducer<GetCompanyCalendlyLinkMeta, GetCompanyCalendlyLinkPayload>(getCompanyCalendlyLinkActions);
